var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "page-outline",
    { attrs: { title: _vm.$t("Webheader.message_list") } },
    [
      _c("template", { slot: "pageContent" }, [
        _c(
          "div",
          { staticClass: "listPage overflow-hidden" },
          [
            _c(
              "b-row",
              { staticClass: "justify-content-start no-gutters" },
              [
                _c(
                  "b-button",
                  {
                    staticClass: "btn btnFilter",
                    attrs: { disabled: _vm.activateSpinner },
                    on: {
                      click: function ($event) {
                        return _vm.onRefresh()
                      },
                    },
                  },
                  [_c("i", { staticClass: "fa-light fa-rotate-right fs-14px" })]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "ml-3 mt-xl-0 text-xl-center" },
                  [
                    _c(
                      "b-button-group",
                      {},
                      [
                        _c(
                          "b-button",
                          {
                            attrs: {
                              variant: _vm.tabName === 0 ? "primary" : "",
                            },
                            on: {
                              click: function ($event) {
                                _vm.tabName = 0
                              },
                            },
                          },
                          [_vm._v(_vm._s(_vm.$t("common.routing.in")))]
                        ),
                        _vm._v(" "),
                        _c(
                          "b-button",
                          {
                            attrs: {
                              variant: _vm.tabName === 1 ? "primary" : "",
                            },
                            on: {
                              click: function ($event) {
                                _vm.tabName = 1
                              },
                            },
                          },
                          [_vm._v(_vm._s(_vm.$t("common.routing.out")))]
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
            _vm._v(" "),
            _c("br"),
            _vm._v(" "),
            _c(
              "b-tabs",
              {
                attrs: { "nav-class": "d-none" },
                model: {
                  value: _vm.tabName,
                  callback: function ($$v) {
                    _vm.tabName = $$v
                  },
                  expression: "tabName",
                },
              },
              [
                _c(
                  "b-tab",
                  { attrs: { title: _vm.$t("common.routing.in") } },
                  [
                    _c(
                      "b-row",
                      [
                        _c(
                          "b-col",
                          { attrs: { md: "12" } },
                          [
                            _vm.activateSpinner
                              ? _c("spinner")
                              : _c(
                                  "div",
                                  [
                                    _vm.messageRoutingIn.length
                                      ? _c("b-table", {
                                          staticClass: "mt-3",
                                          attrs: {
                                            hover: "",
                                            relative: "",
                                            responsive: "",
                                            items: _vm.messageRoutingIn,
                                            fields: _vm.fields,
                                            selectable: "",
                                            "select-mode": "single",
                                          },
                                          on: {
                                            "row-selected": _vm.seeDetails,
                                          },
                                          scopedSlots: _vm._u(
                                            [
                                              {
                                                key: "cell(Standard)",
                                                fn: function (data) {
                                                  return [
                                                    data.value === "1"
                                                      ? _c("span", [
                                                          _vm._v("SRTP"),
                                                        ])
                                                      : data.value === "2"
                                                      ? _c("span", [
                                                          _vm._v("HRTP"),
                                                        ])
                                                      : _c("span"),
                                                  ]
                                                },
                                              },
                                            ],
                                            null,
                                            false,
                                            3931652988
                                          ),
                                        })
                                      : _vm._e(),
                                  ],
                                  1
                                ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "b-tab",
                  { attrs: { title: _vm.$t("common.routing.out") } },
                  [
                    _c(
                      "b-row",
                      [
                        _c(
                          "b-col",
                          { attrs: { md: "12" } },
                          [
                            _vm.activateSpinner
                              ? _c("spinner")
                              : _c(
                                  "div",
                                  [
                                    _vm.messageRoutingOut.length
                                      ? _c("b-table", {
                                          staticClass: "mt-3",
                                          attrs: {
                                            hover: "",
                                            relative: "",
                                            responsive: "",
                                            items: _vm.messageRoutingOut,
                                            fields: _vm.fields,
                                            selectable: "",
                                            "select-mode": "single",
                                          },
                                          on: {
                                            "row-selected": _vm.seeDetails,
                                          },
                                          scopedSlots: _vm._u(
                                            [
                                              {
                                                key: "cell(Standard)",
                                                fn: function (data) {
                                                  return [
                                                    data.value === "1"
                                                      ? _c("span", [
                                                          _vm._v("SRTP"),
                                                        ])
                                                      : data.value === "2"
                                                      ? _c("span", [
                                                          _vm._v("HRTP"),
                                                        ])
                                                      : _c("span"),
                                                  ]
                                                },
                                              },
                                            ],
                                            null,
                                            false,
                                            3931652988
                                          ),
                                        })
                                      : _vm._e(),
                                  ],
                                  1
                                ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
            _vm._v(" "),
            _vm.canAddMessageRouting && !_vm.activateSpinner
              ? _c(
                  "b-row",
                  { staticClass: "justify-content-end mt-3 no-gutters" },
                  [
                    _c(
                      "b-button",
                      {
                        attrs: { variant: "primary" },
                        on: { click: _vm.addMessageRouting },
                      },
                      [
                        _c("i", { staticClass: "fa-light fa-plus fs-17px" }),
                        _vm._v(" "),
                        _c("span", [
                          _vm._v(_vm._s(_vm.$t("common.routing.add_message"))),
                        ]),
                      ]
                    ),
                  ],
                  1
                )
              : _vm._e(),
          ],
          1
        ),
      ]),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }